import { request } from "@/api/server/index";
export default {
  ////V008_最近表示した顧客一覧画面
  RecentlyCustomer: {
    //初期表示
    indexRecentlyCustomer(params) {
      return request({
        url: "/recentlyCustomer/indexRecentlyCustomer",
        data: params,
        method: "post"
      });
    }
  },
  //V009_顧客検索画面
  CustomerSearch: {
    //顧客検索・新規登録 初期表示
    indexCustomerSearch(params) {
      return request({
        url: "/customerSearch/indexCustomerSearch",
        data: params,
        method: "post"
      });
    },
    //顧客検索・新規登録 顧客検索
    searchCustomerList(params) {
      return request({
        url: "/customerSearch/searchCustomerList",
        data: params,
        method: "post"
      });
    },
    //顧客検索・新規登録 被保険者検索
    searchPersonInsuredList(params) {
      return request({
        url: "/customerSearch/searchPersonInsuredList",
        data: params,
        method: "post"
      });
    },
    //テナント内の「顧客」の数と テナントマスタ.最大顧客数 を比較する。
    checkCustomerCount(params) {
      return request({
        url: "/customerSearch/checkCustomerCount",
        data: params,
        method: "post"
      });
    },
    //顧客検索・新規登録 顧客分類一括削除
    deleteCustomerCategoryList(params) {
      return request({
        url: "/customerSearch/deleteCustomerCategoryList",
        data: params,
        method: "post"
      });
    },
    //顧客検索・新規登録 顧客分類一括登録
    updateCustomerCategoryList(params) {
      return request({
        url: "/customerSearch/updateCustomerCategoryList",
        data: params,
        method: "post"
      });
    },
    //顧客検索・新規登録 営業担当者一括変更
    updateCustomerList(params) {
      return request({
        url: "/customerSearch/updateCustomerList",
        data: params,
        method: "post"
      });
    },
    //顧客検索・新規登録  チェック（i23）で選択した顧客のチェック
    checkCustomerExist(params) {
      return request({
        url: "/customerSearch/checkCustomerExist",
        data: params,
        method: "post"
      });
    }
  },
  //V010_顧客登録画面
  CustomerEdit: {
    //顧客登録 初期表示
    indexCustomerEdit(params) {
      return request({
        url: "/customerEdit/indexCustomerEdit",
        data: params,
        method: "post"
      });
    },
    //顧客登録 削除
    deleteCustomerEdit(params) {
      return request({
        url: "/customerEdit/deleteCustomerEdit",
        data: params,
        method: "post"
      });
    },
    //新しい世帯主選択ダイアログで登録（b9）をクリックしたときの処理
    insertFamilyOwner(params) {
      return request({
        url: "/customerEdit/insertFamilyOwner",
        data: params,
        method: "post"
      });
    },
    //顧客登録 登録（新規登録）
    insertCustomerEdit(params) {
      return request({
        url: "/customerEdit/insertCustomerEdit",
        data: params,
        method: "post"
      });
    },
    //顧客登録 登録（編集）
    updateCustomerEdit(params) {
      return request({
        url: "/customerEdit/updateCustomerEdit",
        data: params,
        method: "post"
      });
    },
    //顧客登録 同居顧客の住所を変更
    changeFamilyAddress(params) {
      return request({
        url: "/customerEdit/changeFamilyAddress",
        data: params,
        method: "post"
      });
    }
  },
  //V011_顧客情報画面
  CustomerAllInfo: {
    //顧客情報 初期表示(ヘーダ用基本情報を取得)
    indexCustomerAllInfo(params) {
      return request({
        url: "/customerAllInfo/indexCustomerAllInfo",
        data: params,
        method: "post"
      });
    },
    //顧客情報 初期表示(基本情報以外の情報を取得)
    indexCustomerOtherInfo(params) {
      return request({
        url: "/customerAllInfo/indexCustomerOtherInfo",
        data: params,
        method: "post"
      });
    },
    //添付ファイル名クリック時の処理
    downloadProposalAttachment(params) {
      return request({
        url: "/customerAllInfo/downloadProposalAttachment",
        data: params,
        method: "post",
        responseType: "blob"
      });
    },
    //添付書類を一括削除の処理
    attachedDocumentBatchDelete(params) {
      return request({
        url: "/customerAllInfo/attachedDocumentBatchDelete",
        data: params,
        method: "post"
      });
    },
    //関係者検索画面（V011-3）内の検索処理
    searchRelationalCustomerInfo(params) {
      return request({
        url: "/customerAllInfo/searchRelationalCustomerInfo",
        data: params,
        method: "post"
      });
    },
    //関係者登録画面（V011-4）の初期化
    indexRelationalCustomerRegister(params) {
      return request({
        url: "/customerAllInfo/indexRelationalCustomerRegister",
        data: params,
        method: "post"
      });
    },
    //顧客情報 関係者 削除
    deleteRelationalCustomer(params) {
      return request({
        url: "/customerAllInfo/deleteRelationalCustomer",
        data: params,
        method: "post"
      });
    },
    //顧客情報 関係者 登録(編集)
    updateRelationalCustomer(params) {
      return request({
        url: "/customerAllInfo/updateRelationalCustomer",
        data: params,
        method: "post"
      });
    },
    //世帯構成員の追加前にチェック
    familyCustomerAddCheck(params) {
      return request({
        url: "/customerAllInfo/familyCustomerAddCheck",
        data: params,
        method: "post"
      });
    },
    //テナント内の「顧客」の数と テナントマスタ.最大顧客数 を比較する。
    checkInsuredCustomerCount(params) {
      return request({
        url: "/customerAllInfo/checkCustomerCount",
        data: params,
        method: "post"
      });
    },
    //被保険者顧客検索
    insuredCustomerSearch(params) {
      return request({
        url: "/customerAllInfo/insuredCustomerSearch",
        data: params,
        method: "post"
      });
    },
    //近くの顧客検索
    nearbyCustomerSearch(params) {
      return request({
        url: "/customerAllInfo/nearbyCustomerSearch",
        data: params,
        method: "post"
      });
    },
    //関係者明細再表示変更処理
    researchRelationalCustomerData(params) {
      return request({
        url: "/customerAllInfo/researchRelationalCustomerData",
        data: params,
        method: "post"
      });
    },
    //加入契約一覧作成
    outputContractList(params) {
      return request({
        url: "/customerAllInfo/outputContractList",
        data: params,
        method: "post",
        responseType: "blob"
      });
    }
  },
  //V012_世帯構成員検索画面
  FamilyMemberSearch: {
    //検索（b2）をクリックしたときの処理
    searchFamilyMemberInfo(params) {
      return request({
        url: "/familyMemberSearch/searchFamilyMemberList",
        data: params,
        method: "post"
      });
    },
    //最大顧客数の確認
    customerMaxCountCheck(params) {
      return request({
        url: "/familyMemberSearch/customerMaxCountCheck",
        data: params,
        method: "post"
      });
    },
    //クリックした顧客が複数人世帯の世帯主の確認
    customerFamilyOwnerCheck(params) {
      return request({
        url: "/familyMemberSearch/customerFamilyOwnerCheck",
        data: params,
        method: "post"
      });
    }
  },
  //V013_世帯構成員登録画面
  FamilyMemberEdit: {
    //世帯構成員登録 初期表示
    indexFamilyMemberEdit(params) {
      return request({
        url: "/familyMemberEdit/indexFamilyMemberEdit",
        data: params,
        method: "post"
      });
    },
    //世帯構成員登録 世帯から離脱
    memberDisengage(params) {
      return request({
        url: "/familyMemberEdit/memberDisengage",
        data: params,
        method: "post"
      });
    },
    //世帯構成員登録 新規登録
    insertFamilyMember(params) {
      return request({
        url: "/familyMemberEdit/insertFamilyMember",
        data: params,
        method: "post"
      });
    },
    //世帯構成員登録 成員編集
    updateFamilyMember(params) {
      return request({
        url: "/familyMemberEdit/updateFamilyMember",
        data: params,
        method: "post"
      });
    },
    //世帯構成員登録 同居（i18）の値を変更したときの処理
    liveTogetherChange(params) {
      return request({
        url: "/familyMemberEdit/liveTogetherChange",
        data: params,
        method: "post"
      });
    },
    //同居顧客の住所を変更
    changeFamilyAddress(params) {
      return request({
        url: "/familyMemberEdit/changeFamilyAddress",
        data: params,
        method: "post"
      });
    }
  },
  //V014_顧客名寄せ画面
  CustomerUnification: {
    //顧客名寄せ初期表示データを検索
    indexCustomerUnification(params) {
      return request({
        url: "/customerUnification/indexCustomerUnification",
        data: params,
        method: "post"
      });
    },
    //顧客名寄せ 明細のデータの検索処理
    searchCustomerUnificationList(params) {
      return request({
        url: "/customerUnification/searchCustomerUnificationList",
        data: params,
        method: "post"
      });
    },
    //顧客名寄せ チェック（i4）をクリックしたときの処理
    getCustomerInfo(params) {
      return request({
        url: "/customerUnification/getCustomerInfo",
        data: params,
        method: "post"
      });
    },
    //顧客名寄せ 名寄せ処理
    updateCustomerUnificationList(params) {
      return request({
        url: "/customerUnification/updateCustomerUnificationList",
        data: params,
        method: "post"
      });
    }
  },
  //V086_送付状作成画面
  LetterCreation: {
    //V086_送付状作成画面 初期表示
    indexLetterCreation(params) {
      return request({
        url: "/letterCreation/indexLetterCreation",
        data: params,
        method: "post"
      });
    },
    //V086_送付状作成画面 出先変更
    getBranchInfoByKey(params) {
      return request({
        url: "/letterCreation/getBranchInfoByKey",
        data: params,
        method: "post"
      });
    },
    //V086_送付状作成画面 送付状作成
    outPutLetterCreation(params) {
      return request({
        url: "/letterCreation/outPutLetterCreation",
        data: params,
        method: "post",
        responseType: "blob"
      });
    }
  }
};
